/**
 * Tokens de UI mobile — usados em todos os chips, badges e botões da interface
 * mobile gameficada. Garante que todos os chips têm exatamente o mesmo tamanho
 * e border-radius (rounded-2xl = 1rem = ~16px), conforme design aprovado.
 *
 * Uso:
 *   <button className={`${CHIP_BASE} ${CHIP_ACTIVE}`}>...</button>
 *   <span className={`${BADGE_BASE} bg-red-600 text-white`}>...</span>
 */

// Chip interativo (botão de filtro, toggle, etc.)
// h-9 = 36px, min-w-[72px] garante largura mínima uniforme, rounded-2xl ≈ imagem de referência
export const CHIP_BASE =
  'h-9 min-w-[72px] px-3 rounded-2xl text-xs font-bold flex items-center justify-center touch-action-manip transition-all select-none'

// Chip de filtro não selecionado
export const CHIP_INACTIVE = 'opacity-60'

// Chip de filtro selecionado (anel escuro no tema claro, branco no escuro)
export const CHIP_ACTIVE = 'ring-2 ring-ink/40 dark:ring-white/70 opacity-100'

// Badge estático (sem interação) — h-8 pra não sobrepor o texto do card
export const BADGE_BASE =
  'h-8 min-w-[64px] px-3 rounded-2xl text-xs font-bold flex items-center justify-center whitespace-nowrap'
